var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, property } from '@folkjs/dom/ReactiveElement';
import { AsyncPropagator, Propagator } from '@folkjs/propagators';
import { FolkRope } from './folk-rope';
export class FolkEventPropagator extends FolkRope {
    constructor() {
        super(...arguments);
        this.async = false;
        this.#triggerTextarea = document.createElement('textarea');
        this.#expressionTextarea = document.createElement('textarea');
        this.#propagator = null;
        this.#container = document.createElement('div');
        this.#hasError = false;
    }
    static { this.tagName = 'folk-event-propagator'; }
    static { this.shadowRootOptions = { ...FolkRope.shadowRootOptions, delegatesFocus: true }; }
    static { this.styles = [
        FolkRope.styles,
        css `
      .input-container {
        position: absolute;
        display: flex;
        flex-direction: column;
        translate: -50% -50%;
      }

      textarea {
        width: auto;
        min-width: 3ch;
        height: auto;
        resize: none;
        background: rgba(256, 256, 256, 0.8);
        border: 1px solid #ccc;
        padding: 4px;
        pointer-events: auto;
        overflow: hidden;
        field-sizing: content;
        box-sizing: content-box;
      }

      [part='trigger'] {
        border-radius: 5px 5px 0 0;
        border-bottom: none;
        width: fit-content;
      }

      [part='expression'] {
        border-radius: 0 5px 5px 5px;
      }
    `,
    ]; }
    #triggerTextarea;
    #expressionTextarea;
    #propagator;
    #container;
    #hasError;
    createRenderRoot() {
        const root = super.createRenderRoot();
        this.#container.className = 'input-container';
        this.#triggerTextarea.part.add('trigger');
        this.#expressionTextarea.part.add('expression');
        this.#triggerTextarea.addEventListener('change', () => {
            this.trigger = this.#triggerTextarea.value;
        });
        this.#expressionTextarea.addEventListener('input', () => {
            this.expression = this.#expressionTextarea.value;
        });
        this.#expressionTextarea.addEventListener('focusout', () => {
            if (this.#hasError) {
                super.cut();
            }
        });
        this.#triggerTextarea.value = this.trigger ?? '';
        this.#expressionTextarea.value = this.expression ?? '';
        this.#container.append(this.#triggerTextarea, this.#expressionTextarea);
        root.append(this.#container);
        return root;
    }
    updated(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has('trigger')) {
            this.#triggerTextarea.value = this.trigger ?? '';
        }
        if (changedProperties.has('expression')) {
            this.#expressionTextarea.value = this.expression ?? '';
        }
        if (changedProperties.has('trigger') || changedProperties.has('expression') || changedProperties.has('async')) {
            this.#initializePropagator();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.#propagator?.dispose();
    }
    #initializePropagator() {
        this.#propagator?.dispose();
        if (!(this.source instanceof Element && this.target instanceof Element))
            return;
        const options = {
            source: this.source,
            target: this.target,
            event: this.trigger,
            handler: this.expression,
            onParseError: () => {
                this.#hasError = true;
            },
            onParseSuccess: () => {
                if (this.#hasError) {
                    super.mend();
                }
                this.#hasError = false;
            },
        };
        this.#propagator = this.async ? new AsyncPropagator(options) : new Propagator(options);
    }
    render() {
        super.render();
        const point = this.getPointAt(0.5);
        if (point) {
            this.#container.style.left = `${point.pos.x}px`;
            this.#container.style.top = `${point.pos.y}px`;
        }
    }
    cut(atPercentage) {
        super.cut(atPercentage);
        this.#propagator?.dispose();
    }
    mend() {
        super.mend();
        this.#initializePropagator();
    }
}
__decorate([
    property({ reflect: true })
], FolkEventPropagator.prototype, "trigger", void 0);
__decorate([
    property({ reflect: true })
], FolkEventPropagator.prototype, "expression", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], FolkEventPropagator.prototype, "async", void 0);
//# sourceMappingURL=folk-event-propagator.js.map